import React from "react";
import { Location } from "../Location";
import { ContractForm } from "@consultants/ConsultantContract/ContractForm";
import { ErpContractPrefill } from "@consultants/ConsultantContract/erpPrefill";

interface Params {
  consultantId: string;
  contractId: string;
  action: string;
  /** Set only when the ERP started this contract from a work request (ERP-741). */
  erpPrefill?: ErpContractPrefill;
}

export class ConsultantContractEditorLocation extends Location<Params> {
  constructor(
    consultantId: string,
    contractId: string,
    action: string,
    erpPrefill?: ErpContractPrefill
  ) {
    super({ consultantId, contractId, action, erpPrefill });
  }

  render(): React.ReactElement<any> {
    return (
      <ContractForm
        consultantId={this.params.consultantId}
        contractId={this.params.contractId}
        action={this.params.action}
        erpPrefill={this.params.erpPrefill}
      />
    );
  }

  toURI() {
    const { consultantId, contractId } = this.params;
    return `/consultants/${consultantId}/contract/${contractId || "new"} `;
  }
}
